import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SaveComponent } from '../save/save.component';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { LogoDisplayComponent } from '../question-board/logo-display/logo-display.component';
import { filter, map, take } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { QuestionnaireStatusComponent } from 'src/app/features/questionnaires/features/table-grid/features/questionnaires-list-page/components/questionnaire-status/questionnaire-status.component';
import { EQuestionnaireStatus } from 'src/app/models/questionnaireGrid.model';
import { Location } from '@angular/common';
import { GlobalStore } from 'src/app/store/global-store';
import { QuestionnairesGridStore } from 'src/app/features/questionnaires/store/questionnairesGrid-store';
import { FormControl } from '@angular/forms';
import { environment } from 'src/environment';
import { ToggleComponent } from 'src/app/shared/components/toggle/toggle.component';
import { MatDialog } from '@angular/material/dialog';
import { PopupCreateSettingsComponent } from '../popup-create-settings/popup-create-settings.component';
import { ApproverDefinitionItem } from 'src/app/models/definitionsStyle.model';

@Component({
    selector: 'que-create-header',
    imports: [CommonModule, SaveComponent, LogoDisplayComponent, TranslateDirective, TranslatePipe, QuestionnaireStatusComponent, ToggleComponent],
    templateUrl: './create-header.component.html',
    styleUrls: ['./create-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateHeaderComponent implements OnInit {
  @Output() saveEvent = new EventEmitter();
  #questionnaireStore = inject(QuestionnaireStore);
  #questionnaireGridStore = inject(QuestionnairesGridStore);

  id$ = toSignal(this.#questionnaireStore.questionnaireId$);
  url: any;
  #router = inject(Router);
  #store = inject(QuestionnaireStore);
  #dialog = inject(MatDialog);

  name$ = this.#store.name$;
  status$ = toSignal(this.#store.status$);
  category$ = this.#store.category$;
  eQuestionnaireStatus = EQuestionnaireStatus;
  recentlySave$ = this.#questionnaireStore.recentlySave;
  notLoading$ = toSignal(this.#questionnaireStore.notLoading$);
  notLoadingSave$ = toSignal(this.#questionnaireStore.notLoadingSave$);
  changeNotSavedInCurrentStep$ = toSignal(this.#questionnaireStore.changeNotSavedInCurrentStep$);
  apiExposureEnabled = environment.apiExposureEnabled ?? false;
  approvalRequiredEnabled = environment.featurs.approvalRequired == "ON";
  isApiExposure = new FormControl<boolean | undefined>(undefined);
  isUnauthorized = new FormControl<boolean | undefined>(undefined);
  isApprovalRequired = new FormControl<boolean | undefined>(undefined);
  approversType = new FormControl<ApproverDefinitionItem[] | undefined>(undefined);
  isNotificationEnabled = new FormControl<boolean | undefined>(undefined);
  notificationEmail = new FormControl<string | undefined>(undefined);

  ngOnInit(): void {
    this.isApiExposure.valueChanges.pipe(filter(x => x !== undefined && x !== null)).subscribe(
      (value) => {
        this.#questionnaireStore.updateAfterInitDefinitions();
        this.#questionnaireStore.updatDefinitionsApiExposureEnabled(value!);
        this.#questionnaireGridStore.updateFeatures({ id: this.id$() ?? 0, apiExposure: value ?? false, isUnAuthorized: this.isUnauthorized.value ?? false });
      }
    );
    this.#questionnaireStore.apiExposureEnabled$.subscribe(
      isApiExposure => {
        this.isApiExposure.setValue(isApiExposure, { emitEvent: false })
      }
    )
    this.isUnauthorized.valueChanges.pipe(filter(x => x !== undefined && x !== null)).subscribe(
      (value) => {
        this.#questionnaireStore.updateAfterInitDefinitions();
        this.#questionnaireStore.updatDefinitionsIsUnauthorized(value!);
        this.#questionnaireGridStore.updateFeatures({ id: this.id$() ?? 0, apiExposure: this.isApiExposure.value ?? false, isUnAuthorized: value ?? false });

      }
    );
    this.#questionnaireStore.isUnauthorized$.subscribe(
      isUnauthorized => {
        this.isUnauthorized.setValue(isUnauthorized, { emitEvent: false })
      }
    )
    this.isApprovalRequired.valueChanges.pipe(filter(x => x !== undefined && x !== null)).subscribe(
      (value) => {
        this.#questionnaireStore.updateAfterInitDefinitions();
        this.#questionnaireStore.updatDefinitionsIsApprovalRequired(value!)
      }
    );
    this.approversType.valueChanges.subscribe(
      (value) => {
        this.#questionnaireStore.updateAfterInitDefinitions();
        this.#questionnaireStore.updatApproversType(value!)
      }
    );
    this.#questionnaireStore.isApprovalRequired$.subscribe(
      isApprovalRequired => {
        this.isApprovalRequired.setValue(isApprovalRequired, { emitEvent: false })
      }
    )
    this.#questionnaireStore.approversType$.subscribe(
      approversType => {
        this.approversType.setValue(approversType, { emitEvent: false })
      }
    )
    this.isNotificationEnabled.valueChanges.pipe(filter(x => x !== undefined && x !== null)).subscribe(
      (value) => {
        this.#questionnaireStore.updateAfterInitDefinitions();
        this.#questionnaireStore.updatDefinitionsIsNotificationEnabled(value!)
      }
    );
    this.notificationEmail.valueChanges.pipe(filter(x => x !== undefined && x !== null)).subscribe(
      (value) => {
        this.#questionnaireStore.updateAfterInitDefinitions();
        this.#questionnaireStore.updatDefinitionsNotificationEmail(value!)
      }
    );
    this.#questionnaireStore.isNotificationEnabled$.subscribe(
      isNotificationEnabled => {
        this.isNotificationEnabled.setValue(isNotificationEnabled, { emitEvent: false })
      }
    )
    this.#questionnaireStore.notificationEmail$.subscribe(
      notificationEmail => {
        this.notificationEmail.setValue(notificationEmail, { emitEvent: false })
      }
    )
  }
  back() {
    // this.save();
    this.#router.navigate(["main"]);
    // this.#location.back();
  }
  save() {
    this.saveEvent.emit();
    // this.#questionnaireStore.save();
  }
  goToPreview() {
    this.#router.navigate([`create/${this.id$()}/preview`])
  }

  changeApiExposureEnabled(state: boolean) {
    this.isApiExposure.patchValue(state);
  }
  changeIsUnauthorized(state: boolean) {
    this.isUnauthorized.patchValue(state);
  }
  changeIsApprovalRequired(state: boolean) {
    this.isApprovalRequired.patchValue(state);
  }

  openSettings() {
    this.#dialog.open(PopupCreateSettingsComponent, {
      autoFocus: false,
      data: {
        isApprovalRequired: this.isApprovalRequired.value ?? false,
        isUnauthorized: this.isUnauthorized.value ?? false,
        isApiExposure: this.isApiExposure.value ?? false,
        selectedApprovers: this.approversType.value,
        isNotificationEnabled: this.isNotificationEnabled.value ?? false,
        notificationEmail: this.notificationEmail.value ?? ''
      }
    }).afterClosed().subscribe((result) => {
      if (!result) return;
      this.isApprovalRequired.patchValue(result.isApprovalRequired);
      this.isUnauthorized.patchValue(result.isUnauthorized);
      this.isApiExposure.patchValue(result.isApiExposure);
      this.approversType.patchValue(result.selectedApprovers);
      this.isNotificationEnabled.patchValue(result.isNotificationEnabled);
      this.notificationEmail.patchValue(result.notificationEmail);


    });
  }
}
